import type { TrainingServiceStandardDetailModel } from "../ui/TrainingServiceStandardDetailView";

export function mapApiToServiceStandardDetail(
  row: Record<string, unknown>,
): TrainingServiceStandardDetailModel {
  const items = (row.items as TrainingServiceStandardDetailModel["items"]) ?? [];
  const examples = (row.examples as TrainingServiceStandardDetailModel["examples"]) ?? [];
  const specialCases =
    (row.specialCases as TrainingServiceStandardDetailModel["specialCases"]) ?? [];
  return {
    id: String(row.id),
    name: String(row.name),
    description: (row.description as string | null) ?? null,
    serviceStage: String(row.serviceStage),
    status: String(row.status),
    updatedAt: row.updatedAt as Date | string,
    serviceChannelName: (row.serviceChannelName as string | null) ?? null,
    departmentName: (row.departmentName as string | null) ?? null,
    positionTitle: (row.positionTitle as string | null) ?? null,
    items,
    examples,
    specialCases,
  };
}
